export const DISAGREE = 'Disagree';
export const AGREE = 'Agree';
export const CAN_NOT_BE_UNDONE_MESSAGE = 'This action cannot be undone.';
